import { FC, ReactNode, useState, useMemo, useEffect, useContext } from 'react'
import { experimentalStyled } from '@material-ui/core/styles'
import { Box } from '@material-ui/core'
import { Outlet } from 'react-router-dom'
import Header from '../Header'
import SideNav from '../Sidenav'
import { IconButton, Tooltip } from '@material-ui/core'
import { Typography } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { ReactComponent as AiIcon } from '../../../src/Icons/AiIcon.svg'
import Axios from '../../Utils/AxiosConfig/axiosConfig'
import CancelIcon from '@mui/icons-material/Cancel'
import ReactWebChat, { createDirectLine } from 'botframework-webchat'
import { env } from '../../env'
import React from 'react'
import { AppContext } from '../../App'
interface SidebarWithHeaderLayoutProps {
	children?: ReactNode
}

const MainWrapper = experimentalStyled(Box)<{ open: boolean }>(
	({ theme, open }) => `
  flex: 1 1 auto;
  display: flex;
  height: 100%;
  padding-left: ${open ? '320px' : '80px'};`
)

const MainContent = experimentalStyled(Box)(
	({ theme }) => `
  margin-top: ${theme.header.height};
  flex: 1 1 auto;
  overflow: auto;
  `
)

export const WindowContext = React.createContext<any>(null)

const SidebarWithHeaderLayout: FC<SidebarWithHeaderLayoutProps> = () => {
	const dispatch = useDispatch()
	const usersList = useSelector((state: any) => state.usersList)
	const [directLineURL, setDirectLineURL] = useState('')
	const [token, setToken] = useState('')
	const [open, setOpen] = useState(false)
	const [isIframeLoaded, setIsIframeLoaded] = useState(false)
	const { chatbotOpenStatus, setChatbotOpenStatus } = useContext<any>(AppContext);
    const shouldShowBot = usersList.currentUser.role === "ARCH_INTELLIGENCE";
	const directLine = useMemo(() => {
   if (!shouldShowBot || !token || !directLineURL) {
   return null;
 }
   return createDirectLine({
   domain: directLineURL,
   token,
 });
},
 [shouldShowBot, token, directLineURL]);
	const userId = usersList.currentUser.user_ad_id
	const showAIToolTip = usersList.currentUser.show_arch_inteligence_tooltip
	const hasARCHInteligence =
		usersList.currentUserPermissions.includes('ARCH_INTELLIGENCE')
	const apiVersion = env.AI_url_version
	const tokenEndpointURL = env.AI_url
	const styleOptions = {
		hideUploadButton: true
	}

	useEffect(() => {
   if (!shouldShowBot) {
       setDirectLineURL('');
       setToken('');
       return;
   }
   const fetchData = async () => {
       try {
           const [directLineURL, token] = await Promise.all([
               fetch(
                   new URL(
                       `/powervirtualagents/regionalchannelsettings?api-version=${apiVersion}`,
                       tokenEndpointURL
                   )
               )
                   .then(response => {
                       if (!response.ok) {
                           throw new Error(
                               'Failed to retrieve regional channel settings.'
                           );
                       }
                       return response.json();
                   })
                   .then(({ channelUrlsById: { directline } }) => directline),
               fetch(tokenEndpointURL)
                   .then(response => {
                       if (!response.ok) {
                           throw new Error(
                               'Failed to retrieve Direct Line token.'
                           );
                       }
                       return response.json();
                   })
                   .then(({ token }) => token)
           ]);
           setDirectLineURL(`${directLineURL}v3/directline`);
           setToken(token);
       } catch (error) {
           // Existing error handling retained
       }
   };
   fetchData();
}, [shouldShowBot, apiVersion, tokenEndpointURL]);

	const toggleCTA = (action: string) => {
		setOpen(action === 'open' ? true : false)
	}

	const handleChatbotClick = () => {
		setChatbotOpenStatus(!chatbotOpenStatus)
		if (!isIframeLoaded) {
			setIsIframeLoaded(true)
		}
		if (showAIToolTip !== false) {
			if (usersList.currentUser._id) {
				Axios.put(`users/${usersList.currentUser._id}`, {
					show_arch_inteligence_tooltip: false
				}).then((response: any) => {
					dispatch({
						type: 'UPDATE_USER',
						payload: response?.data
					})
					dispatch({
						type: 'UPDATE_CURRENT_USER',
						payload: response?.data
					})
				})
			}
		}
	}

	return (
		<>
			{/* <Sidebar /> */}
			<SideNav toggleAction={toggleCTA} />
			<div style={{ display: 'flex', height: '100%' }}>
				<div style={{ width: chatbotOpenStatus ? '85%' : '100%' }}>
					<MainWrapper open={open}>
						<Header />
						<MainContent>
							<WindowContext.Provider value={{ openChatbot: chatbotOpenStatus }}>
								<Outlet />
							</WindowContext.Provider>
						</MainContent>
					</MainWrapper>
				</div>
				<div
					className='chatbot-container'
					style={{
						height: '100%',
						width: '15%',
						display: chatbotOpenStatus ? 'inline-flex' : 'none',
						flexDirection: 'column',
						padding: '68px 8px 8px 8px',
						minWidth: '290px'
					}}
				>
					<CancelIcon
						sx={{
							fontSize: '20px',
							position: 'absolute',
							top: '80px',
							right: '20px',
							color: 'white',
							background: '#006098',
							zIndex: 10
						}}
						onClick={handleChatbotClick}
					/>

					<div
						style={{
							width: '100%',
							backgroundColor: '#006098',
							zIndex: 2,
							height: 46,
							borderTopRightRadius: 12,
							borderTopLeftRadius: 12,
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'left'
						}}
					>
						<div style={{ fontSize: 14, fontWeight: 'bold', marginLeft: 10 }}>
							Dimitri ARCH
						</div>
					</div>

					{shouldShowBot && directLine && (
						<ReactWebChat
							directLine={directLine}
							styleOptions={styleOptions}
							userID={userId}
						/>
					)}
				</div>

				{hasARCHInteligence && !chatbotOpenStatus && (
					<Box
						sx={{
							position: 'fixed',
							bottom: 30,
							right: 30,
							width: { xs: '28%', sm: 'unset' },
							textAlign: 'right'
						}}
					>
						{showAIToolTip !== false && (
							<Box
								sx={{
									backgroundColor: '#8476EF',
									padding: 1,
									borderRadius: 1,
									boxShadow: 1,
									mb: 1,
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center'
								}}
								onClick={handleChatbotClick}
							>
								<Typography variant='body1'>
									Hi, Im ARCH Intelligence,
									<br /> How can I help you?
								</Typography>
							</Box>
						)}
						<Tooltip arrow title='Dimitri ARCH'>
							<IconButton
								aria-label='delete'
								onClick={handleChatbotClick}
								size='medium'
								style={{
									background: '#8476EF',
									borderRadius: '50%',
									fontSize: '35px'
								}}
							>
								<AiIcon />
							</IconButton>
						</Tooltip>
					</Box>
				)}
			</div>
		</>
	)
}

export default SidebarWithHeaderLayout
